import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IApprovalRequestParams } from "./models";

type InitialState = {
  transactionReportParams: IApprovalRequestParams;
};

const initialState: InitialState = {
  transactionReportParams: {},
};

const reportSlice = createSlice({
  name: "data-generation",
  initialState: initialState,

  reducers: {
    updateTransactionReportParams: (state, action: PayloadAction<IApprovalRequestParams>) => {
      state.transactionReportParams = action.payload;
    },
  },
});

export default reportSlice.reducer;
export const { updateTransactionReportParams } = reportSlice.actions;
